import React, { useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Title from "../../new-components/title/Title";
import HeaderInner from "../../Components/HeaderInner";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";
import { Zoom } from "react-reveal";
import Overllay from "../../assets/new_imgs/Rectangle 1072.png";

// Import local images
import globalImg from "../../assets/new_imgs/Local.jpg";
import localImg from "../../assets/new_imgs/Regional.jpg";
import worldwideImg from "../../assets/new_imgs/World-wide.jpg";
import Img from "../../assets/new_imgs/FB.jpg";

function E_SimTypes() {
  const navigate = useNavigate();
  const location = useLocation();
  const rawPath = location.pathname;
  const { t } = useTranslation();
  const { company_id } = useParams();
  const room_uuid = rawPath.split("/")[1];
  const lang = localStorage.getItem("lang");
  const new_design = localStorage.getItem("new_design");
  const theme = new_design === "true";

  const simCompanies = [
    { name: t("Local"), image: localImg, slug: "local" },
    { name: t("Regional"), image: globalImg, slug: "global" },

    { name: t("Worldwide"), image: worldwideImg, slug: "world" },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`${theme && "food"} ${lang === "AR" && "arabic"}`}>
      {theme ? (
        <Title title={t("eSIM")} />
      ) : (
        <HeaderInner headerName={t("eSIM")} />
      )}

      <main className="box_food image_services home-main bg-white back-white ">
        {simCompanies.map((company) =>
          theme ? (
            <div key={company.slug}>
              <Link to={`/${room_uuid}/sims/${company_id}/${company.slug}`}>
                <img
                  src={company.image}
                  alt={company.name}
                  className="booking_img"
                />
                <img src={Overllay} alt="" className="overlay" />
                <div className="text_food">
                  <h5>{company.name}</h5>
                </div>
              </Link>
            </div>
          ) : (
            <div id={company.name} key={company.slug}>
              <Zoom>
                <div
                  className="con-img-container v3"
                  onClick={() =>
                    navigate(`/${room_uuid}/sims/${company_id}/${company.slug}`)
                  }
                >
                  <div className="con-img">
                    <img src={company.image} alt={company.name} />
                  </div>
                </div>
                <div className="con-text-container">
                  <p>{company.name}</p>
                  <hr className="mb-0 dark" />
                </div>
              </Zoom>
            </div>
          )
        )}
      </main>
    </div>
  );
}

export default E_SimTypes;
